'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  // BLK v2 configs
  candidates: {
    resource: {
      path: 'v2/candidates/me',
      update_path: 'v2/candidates'
    },
    unique_email_check: {
      path: 'v2/candidates/unique_email_check'
    }
  },
  partial_candidates: {
    resource: {
      path: 'v2/partial_candidates'
    }
  },
  complaints: {
    resource: {
      path: 'v2/complaints'
    }
  },
  file_uploads: {
    resource: {
      path: 'v2/file_uploads'
    }
  },
  job_opening_favorites: {
    resource: {
      path: 'v2/job_opening_favorites'
    },
    toggle: {
      path: 'v2/job_opening_favorites/toggle'
    },
    send_to_email: {
      path: 'v2/candidates/mail_favorite_job_openings'
    }
  },
  educations: {
    resource: {
      path: 'v2/educations'
    }
  },
  job_openings: {
    resource: {
      path: 'v2/job_openings'
    }
  },
  polls: {
    resource: {
      path: 'v2/polls'
    }
  },
  locations: {
    resource: {
      path: 'v2/locations'
    }
  },
  sessions: {
    resource: {
      path: 'v2/sessions'
    }
  },
  settings_data: {
    resource: {
      path: 'v2/search_settings/options_lists'
    }
  },
  zipcodes: {
    suggest: {
      path: 'v2/zipcodes/suggest'
    },
    zipcode_and_number: {
      path: 'v2/zipcodes'
    }
  },
  matching_job_openings: {
    resource: {
      path: 'v2/candidates/matching_job_openings'
    }
  },
  //CV Builder
  services: {
    cvbuilder: {
      path: 'v2/services/cvbuilder'
    }
  },
  // AFAS config
  declarations: {
    resource: {
      path: 'v1/declarations'
    },
    status_update: {
      path: 'v1/declarations/update_status'
    }
  },
  declaration_lines: {
    resource: {
      path: 'v1/declaration_lines'
    },
    week_totals: {
      path: 'v1/declaration_lines/week_totals'
    },
    schedules: {
      path: 'v1/declaration_lines/schedules'
    },
    reservations: {
      path: 'v1/reservations'
    }
  },
  declaration_status: {
    resource: {
      path: 'v2/declaration_status'
    }
  },
  documents: {
    resource: {
      path: 'v1/documents'
    }
  },
  contracts: {
    resource: {
      path: 'v1/contracts'
    }
  },
  approvals: {
    resource: {
      path: 'v1/approvals'
    }
  },
  invoices: {
    resource: {
      path: 'v1/invoices'
    }
  },
  payments: {
    resource: {
      path: 'v1/payments'
    }
  },
  tasks: {
    resource: {
      path: 'v1/tasks'
    }
  },
  leave_periods: {
    resource: {
      path: 'v1/leave_periods'
    },
    balances: {
      path: 'v1/leave_periods/balances'
    },
    new: {
      path: 'v1/leave_periods/new'
    }
  },
  reservations: {
    resource: {
      path: 'v1/reservations'
    },
    lines: {
      path: 'v1/reservation_lines'
    }
  },
  payslips: {
    resource: {
      path: 'v1/payslips'
    }
  },
  // WORKER DASHBOARD
  worker_dashboard: {
    resource: {
      path: 'v1/candidate'
    }
  },
  reservation_balances: {
    resource: {
      path: 'v1/reservation_balances'
    }
  },
  calendars: {
    resource: {
      path: 'v1/calendars'
    }
  },
  availabilities: {
    resource: {
      path: 'v1/availabilities'
    }
  }
};